import React from 'react'
import '../../assets/icon/index'

export type IconfontNames =
  | 'github'
  | 'medium'
  | 'email'
  | 'twitter'
  | 'linkedin'
  | 'telegram'
  | 'document'
  | 'discord'

export interface IconfontProps {
  name: IconfontNames
  link?: string
}

export const Iconfont: React.FC<IconfontProps> = ({ name, link }) => {
  const icon = <span className={`sandbags-icon icon-sb-${name}`}></span>
  if (link) {
    return (
      <a href={link} target="_blank">
        {icon}
      </a>
    )
  }
  return icon
}
